import React, {useCallback, useState} from 'react';
import * as PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import '../configure/Configure.css';
import {
  Icon, Row, Layout, Typography, Col,
} from 'antd';
import ViaMenu from '../../../components/menu/ViaMenu';
import ViaDropMenu from '../../../components/menu/ViaDropMenu';
import routeLocations, { entryRoutes, adminRoutes } from '../../../utility/route-locations';
import ConfigContext from '../configure/ConfigContext';
import bynxMenuStructure from './bynxMenuStructure';
import { selectSessionUser } from '../../../state/ui/application/sessionUiReducer';
import { userIsAdminConsole } from '../../../utility/security/security-util';
import PackagePurchases from './reports/PackagePurchases';
import EditLegalDocument from './config/EditLegalDocument';
import CreditEnquiry from './reports/CreditEnquiry';
import EditCompanyDetails from './config/EditCompanyDetails';

const {
  Header, Content, Sider,
} = Layout;
const { Text } = Typography;

function AdminStart() {
  return (
    <div className="not-found-wrapper-configure" style={{ backgroundColor: 'transparent' }}>
      <Row>
        <Icon className="via-config-start-icon" type="setting" />
      </Row>
      <Row>
        <Text className="via-config-start-text"><FormattedMessage id="headingText" /></Text>
      </Row>
    </div>
  );
}

function AdminRoutes() {
  const getMenuRoute = item => (<Route path={item.path} component={item.component} />);
  const getGroupRoutes = group => (group.items.map(item => (getMenuRoute(item))));
  return (
    <Switch>
      <Route path={`${adminRoutes.admin_package_sales}/:id`} component={PackagePurchases} />
      <Route path={`${adminRoutes.admin_legal_documents}/edit/:id`} component={EditLegalDocument} />
      <Route path={`${adminRoutes.admin_company_details}/edit`} component={EditCompanyDetails} />
      <Route path={`${adminRoutes.admin_credit_enquiry}/:id`} component={CreditEnquiry} />
      { bynxMenuStructure.groups.map(group => (getGroupRoutes(group))) }
      <Route path={entryRoutes.adminConsole} component={AdminStart} />
    </Switch>
  );
}

function AdminConsole({ sessionUser }) {
  const [mobile, setMobile] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const [openMenu, setOpenMenu] = useState(true);
  const changeMenu = useCallback((open) => {
    setOpenMenu(open);
  }, []);
  const onBreakpoint = (smaller) => {
    setCollapsed(smaller);
    changeMenu(!smaller);
    setMobile(smaller);
  };

  if (!userIsAdminConsole(sessionUser)) {
    return (<Redirect to={routeLocations.notFound} />);
  }

  return (
    <ConfigContext.Provider value={{
      mobile, setMobile,
    }}
    >
      <Layout className="via-centre via-layout-configure-main" style={{ maxWidth: '100%' }}>
        <Sider
          className="via-sider-configure"
          collapsible
          collapsed={collapsed}
          collapsedWidth={0}
          width={200}
          breakpoint="md"
          trigger={null}
          onBreakpoint={onBreakpoint}
        >
          <Header className="via-header-configure">
            <Row type="flex" align="top" justify="start">
              <Col>
                <Icon className="via-header-cell-configure-text" type="setting" />
                <Text className="via-header-cell-configure-text"><FormattedMessage id="configure" /></Text>
              </Col>
            </Row>
          </Header>
          <Content className="via-sider-configure-body">
            <ViaMenu mode="inline" menuStructure={bynxMenuStructure} sessionUser={sessionUser} />
          </Content>
        </Sider>
        <Layout className={`via-layout-configure${openMenu ? '' : '-mobile'}`}>
          <Header className="via-header-configure-mobile" style={{ display: (openMenu ? 'none' : '') }}>
            <Row type="flex" align="top" justify="start">
              <Col className="via-configure-menu-mobile">
                <ViaDropMenu
                  mode="horizontal"
                  menuStructure={bynxMenuStructure}
                  subMenuTitle={(
                    <Row type="flex" align="middle" justify="start" style={{ height: '32px' }}>
                      <Icon className="via-header-cell-configure-text" type="menu" />
                      <Text className="via-header-cell-configure-text"><FormattedMessage id="configure" /></Text>
                    </Row>
                    )}
                  sessionUser={sessionUser}
                />
              </Col>
            </Row>
          </Header>
          <Content className="via-configure-content">
            <AdminRoutes />
          </Content>
        </Layout>
      </Layout>
    </ConfigContext.Provider>
  );
}

AdminConsole.propTypes = {
  sessionUser: PropTypes.shape({
    username: PropTypes.string.isRequired,
  }).isRequired,
};

/**
 * A function for connecting redux state to the component props.
 */
const mapStateToProps = state => ({
  sessionUser: selectSessionUser(state),
});

/**
 * A function for connecting redux action to the component props.
 */
const mapDispatchToProps = () => ({
});

/**
 * Connect the redux state to our component.
 */
export default connect(mapStateToProps, mapDispatchToProps)(AdminConsole);
